"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireDefault(require("../Button/Button"));
var _constants = require("../constants");
var _Home = _interopRequireDefault(require("./pages/Home"));
var _GiveUsACall = _interopRequireDefault(require("./pages/GiveUsACall"));
var _GetInTouch = _interopRequireDefault(require("./pages/GetInTouch"));
var _Chat = _interopRequireDefault(require("./pages/Chat"));
var _Email = _interopRequireDefault(require("./pages/Email"));
var _BookCall = _interopRequireDefault(require("./pages/BookCall"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var pages = {
  home: _Home["default"],
  call: _GiveUsACall["default"],
  getInTouch: _GetInTouch["default"],
  chat: _Chat["default"],
  email: _Email["default"],
  bookCall: _BookCall["default"]
};
var ContactTabs = function ContactTabs(props) {
  var _useState = (0, _react.useState)('home'),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    activePage = _useState2[0],
    setActivePage = _useState2[1];
  var ActivePage = pages[activePage];
  var brand = props.brand;
  var emailAddress = 'info@theyachtweek.com';
  var showWhatsapp = true;
  switch (brand) {
    case 'tyw':
      emailAddress = 'hello@theyachtweek.com';
      break;
    case 'tsw':
      emailAddress = 'hello@theskiweek.com';
      break;
    case 'ynf':
      emailAddress = 'info@yachtsandfriends.com';
      break;
    case 'qd':
      emailAddress = 'info@quarterdeck.co';
      showWhatsapp = false;
      break;
    default:
      emailAddress = 'info@theyachtweek.com';
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-c-contact-tabs position-relative"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      zIndex: 1
    }
  }, activePage !== 'home' && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: "",
    text: "Back",
    buttonType: _constants.BUTTON_TYPES.BARE_NO_PADDING,
    icon: "arrow-left",
    onClick: function onClick() {
      return setActivePage('home');
    }
  }), /*#__PURE__*/_react["default"].createElement("hr", {
    className: "d8-u-contrast-low-bg width-100% margin-y-md",
    style: {
      height: '1px'
    }
  })), /*#__PURE__*/_react["default"].createElement(ActivePage, (0, _extends2["default"])({}, props, {
    setActivePage: setActivePage,
    emailAddress: emailAddress,
    showWhatsapp: showWhatsapp
  }))));
};
ContactTabs.propTypes = {
  brand: _propTypes["default"].string.isRequired,
  isPoweredBy: _propTypes["default"].bool
};
var _default = exports["default"] = ContactTabs;